export default __webpack_public_path__ + "static/media/wordpress.163063a2.png";